// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { TypographyProps } from "@insite/mobius/Typography";
import { ellipsis } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

const nameText: TypographyProps = {
    css: css`
        width: 100%;
        ${ellipsis(1)};
        ${wrapInContainerStyles}
    `,
    size: "12px",
    lineHeight: "15px",
    weight: 400,
    color: "text.main",
};

productBrandStyles.nameText = { ...nameText };

productBrandStyles.nameLink = {
    color: "text.main",
    css: css`
        width: auto;
        align-self: baseline;
        margin-bottom: 4px;
    `,
    typographyProps: { ...nameText },
};
